import { ReactNode } from 'react';
import View from '../view';
import { Colors, Spacing, Styles } from '../../../constants/theme';
import { FelaExtend } from '../../../types/fela';

type CardProps = {
  children?: ReactNode;
  extend?: FelaExtend;
};

export const Card = ({ children, extend }: CardProps) => (
  <View extend={[styles.card, extend]}>{children}</View>
);

const styles = {
  card: {
    display: 'flex',
    flexDirection: 'column',
    gap: `${8 * Spacing.gap}px`,
    width: '100%',
    height: '100%',
    boxSizing: 'border-box',
    backgroundColor: Colors.light.secondaryBackground,
    borderRadius: `${Styles.BorderRadius}px`,
    ...Colors.shadowStyle,
    padding: `${10 * Spacing.padding}px`,
  },
};
